import { InfoRegular } from '@fluentui/react-icons'
import * as Tooltip from '@radix-ui/react-tooltip'
import { useState, useEffect } from 'react'
import styles from './InfoLabel.module.css'

interface InfoLabelProps {
    label: React.ReactNode
    info: React.ReactNode
    className?: string
    iconSize?: number
}

export const InfoLabel = ({
    info,
    label,
    className,
    iconSize = 18,
}: InfoLabelProps) => {
    const [isMobile, setIsMobile] = useState(false)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        setIsMobile('ontouchstart' in window || navigator.maxTouchPoints > 0)
    }, [])

    return (
        <div className={`${styles.infoLabel} ${className || ''}`}>
            <span className={styles.text}>{label}</span>
            <Tooltip.Provider delayDuration={100}>
                <Tooltip.Root
                    open={isMobile ? open : undefined}
                    onOpenChange={setOpen}
                >
                    <Tooltip.Trigger asChild>
                        <button
                            className={styles.button}
                            aria-label="More information"
                            style={{ fontSize: iconSize }}
                            onClick={(e) => {
                                if (isMobile) {
                                    e.preventDefault()
                                    setOpen(!open)
                                }
                            }}
                        >
                            <InfoRegular />
                        </button>
                    </Tooltip.Trigger>
                    <Tooltip.Portal>
                        <Tooltip.Content className={styles.tooltipContent}>
                            {info}
                            <Tooltip.Arrow className={styles.tooltipArrow} />
                        </Tooltip.Content>
                    </Tooltip.Portal>
                </Tooltip.Root>
            </Tooltip.Provider>
        </div>
    )
}
